import {WithNameAndIdentity} from './identifiable';
import {Address} from './address';
import {Campaign} from './campaign';

export interface Location extends WithNameAndIdentity {
  address: Address;
  placeId: string;
}

export function locationDisplayFunction(location: Location): string {
  let address = '';

  if (location.address.streetNumber) {
    address += location.address.streetNumber + ' ';
  }

  if (location.address.street) {
    address += location.address.street;
  }

  if (location.address.city) {
    address += ', ' + location.address.city;
  }

  if (address) {
    return `${location.name} - ${address}`;
  }

  return location.name;
}

export function getCampaignLocationDisplayString(campaign: Campaign): string | undefined {
  if (campaign.locationsGroup?.locations && campaign.locationsGroup.locations!.length > 0) {
    return locationDisplayFunction(campaign.locationsGroup.locations![0])
  }
  return undefined;
}
